module.exports = __webpack_public_path__ + "img/back_ground.86b71a2d.svg";